import { IUser, User, UserPolicies } from '@packlink/packlink-sdk';
import Packlink from '@sdk';
import { ReduxAction, ReduxDispatch } from '@store';
import { IAppState } from '@store/reducers';
import { getUser } from '@store/selectors';
import { IPolicy } from '@types';
import { setSentryUser } from '@utils';
import { SET_USER } from './action-types';

export interface ISetUserAction {
    type: 'SET_USER';
    payload: User;
}

export type UserAction = ISetUserAction;

export const setUserAction = (data: User): ISetUserAction => ({ type: SET_USER, payload: data });

export const getUserAction =
    (): ReduxAction<Promise<User | void>> =>
    async (dispatch: ReduxDispatch): Promise<User | void> => {
        return Packlink.v1.users.get().then((user: User) => {
            setSentryUser(user);
            dispatch(setUserAction(user));

            return user;
        });
    };

export const updateUserPoliciesAction =
    (policies: IPolicy, source: string): ReduxAction<Promise<void>> =>
    async (dispatch: ReduxDispatch, getState): Promise<void> => {
        const state: IAppState = getState();
        const user: IUser = getUser(state);

        const userPolicies = UserPolicies.deserialize({
            ...{
                dataProcessing: true,
                marketingCalls: !!user?.policies?.marketingCalls,
                marketingEmails: !!user?.policies?.marketingEmails,
            },
            ...policies,
        });

        return Packlink.v1.users.policies.update(user.id, userPolicies, source).then(() => {
            const updatedUser = User.deserialize({ ...user, policies: { ...userPolicies.toJSON() } });
            dispatch(setUserAction(updatedUser));
        });
    };
